import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import { useNavigate } from "react-router-dom";

function Checkout() {
  const { cart, clearCart } = useContext(CartContext);
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [orderConfirmed, setOrderConfirmed] = useState(false);

  const totalPrice = cart.reduce((total, item) => total + item.price * item.quantity, 0);

  const handleSubmit = (e) => {
    e.preventDefault();
    setOrderConfirmed(true);

    clearCart();

    setTimeout(() => {
      navigate("/");
    }, 3000);
  };

  return (
    <div className="checkout-container">
      <h2>Checkout</h2>

      {orderConfirmed ? (
        <div className="confirmation-message">
          <h3>🎉 Order Confirmed! 🎉</h3>
          <p>Thank you for your purchase! Your order is being processed.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <label> Address: </label>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          />

          <h3>Total Amount: ₹{totalPrice}</h3>

          <button type="submit" className="confirm-btn">Confirm Order</button>
        </form>
      )}
    </div>
  );
}

export default Checkout;
